import styled from 'styled-components';

export const StyledHeader = styled.header`
  background-color: transparent;
  padding: 20px;
  height: 10vh;
`;
